import { DocumentCategoryDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentCategoryService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getDocumentCategory(): Observable<DocumentCategoryDto[]> {
    return this.http.get<DocumentCategoryDto[]>(this.url + 'document-category');
  }

  createDocumentCategory(
    data: DocumentCategoryDto[]
  ): Observable<DocumentCategoryDto[]> {
    return this.http.post<DocumentCategoryDto[]>(
      this.url + 'document-category',
      data
    );
  }
  getSingleDocumentCategory(id: string): Observable<any> {
    return this.http.get(this.url + 'document-category/' + id);
  }

  updateDocumentCategory(
    data: DocumentCategoryDto[]
  ): Observable<DocumentCategoryDto[]> {
    return this.http.post<DocumentCategoryDto[]>(
      this.url + 'document-category/update',
      data
    );
  }

  deleteDocumentCategory(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('document-category', ids.join(', '));
    return this.http.delete(this.url + 'document-category', httpOptions);
  }
}
